/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateResourceDto } from '../model/createResourceDto';
import { ModifyResourceDto } from '../model/modifyResourceDto';
import { ProblemDetails } from '../model/problemDetails';
import { ReadClientResourceDetailDto } from '../model/readClientResourceDetailDto';
import { ReadResourceDto } from '../model/readResourceDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ResourceService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceCreateResourcePost(body?: CreateResourceDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiResourceCreateResourcePost(body?: CreateResourceDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiResourceCreateResourcePost(body?: CreateResourceDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiResourceCreateResourcePost(body?: CreateResourceDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Resource/CreateResource`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceDeleteResourceDelete(resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiResourceDeleteResourceDelete(resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiResourceDeleteResourceDelete(resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiResourceDeleteResourceDelete(resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('ResourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/Resource/DeleteResource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetAllResourceGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadResourceDto>>;
    public apiResourceGetAllResourceGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadResourceDto>>>;
    public apiResourceGetAllResourceGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadResourceDto>>>;
    public apiResourceGetAllResourceGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadResourceDto>>('get',`${this.basePath}/api/Resource/GetAllResource`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetResourceByResourceIdGet(resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadResourceDto>;
    public apiResourceGetResourceByResourceIdGet(resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadResourceDto>>;
    public apiResourceGetResourceByResourceIdGet(resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadResourceDto>>;
    public apiResourceGetResourceByResourceIdGet(resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('ResourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadResourceDto>('get',`${this.basePath}/api/Resource/GetResourceByResourceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetResourceByResourceNameGet(resourceName?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadResourceDto>;
    public apiResourceGetResourceByResourceNameGet(resourceName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadResourceDto>>;
    public apiResourceGetResourceByResourceNameGet(resourceName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadResourceDto>>;
    public apiResourceGetResourceByResourceNameGet(resourceName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceName !== undefined && resourceName !== null) {
            queryParameters = queryParameters.set('ResourceName', <any>resourceName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadResourceDto>('get',`${this.basePath}/api/Resource/GetResourceByResourceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemIdentifier 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetResourceBySystemIdGet(systemIdentifier?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadResourceDto>;
    public apiResourceGetResourceBySystemIdGet(systemIdentifier?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadResourceDto>>;
    public apiResourceGetResourceBySystemIdGet(systemIdentifier?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadResourceDto>>;
    public apiResourceGetResourceBySystemIdGet(systemIdentifier?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemIdentifier !== undefined && systemIdentifier !== null) {
            queryParameters = queryParameters.set('SystemIdentifier', <any>systemIdentifier);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadResourceDto>('get',`${this.basePath}/api/Resource/GetResourceBySystemId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetResourceDataWithClientIdGet(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadClientResourceDetailDto>;
    public apiResourceGetResourceDataWithClientIdGet(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientResourceDetailDto>>;
    public apiResourceGetResourceDataWithClientIdGet(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientResourceDetailDto>>;
    public apiResourceGetResourceDataWithClientIdGet(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadClientResourceDetailDto>('get',`${this.basePath}/api/Resource/GetResourceDataWithClientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param merchantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceGetResourcesByMerchantIdGet(merchantId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReadResourceDto>>;
    public apiResourceGetResourcesByMerchantIdGet(merchantId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadResourceDto>>>;
    public apiResourceGetResourcesByMerchantIdGet(merchantId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadResourceDto>>>;
    public apiResourceGetResourcesByMerchantIdGet(merchantId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (merchantId !== undefined && merchantId !== null) {
            queryParameters = queryParameters.set('MerchantId', <any>merchantId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadResourceDto>>('get',`${this.basePath}/api/Resource/GetResourcesByMerchantId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiResourceUpdateResourcePut(body?: ModifyResourceDto, observe?: 'body', reportProgress?: boolean): Observable<ReadResourceDto>;
    public apiResourceUpdateResourcePut(body?: ModifyResourceDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadResourceDto>>;
    public apiResourceUpdateResourcePut(body?: ModifyResourceDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadResourceDto>>;
    public apiResourceUpdateResourcePut(body?: ModifyResourceDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ReadResourceDto>('put',`${this.basePath}/api/Resource/UpdateResource`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
